
export default function CTASection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-24 bg-[#FAFAFA]">
      <div className="max-w-6xl mx-auto px-6">
        <div className="relative rounded-3xl overflow-hidden mb-12 h-80">
          <img
            src="https://public.readdy.ai/ai/img_res/8940c7e17cd9e546ecf490b6b2f17e00.jpg"
            alt="청주 아이폰수리 마켓 매장"
            className="w-full h-full object-cover"
            style={{ filter: 'contrast(1.1) brightness(0.95)' }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
        </div>

        <div className="text-center">
          <h2 className="text-4xl md:text-5xl font-light text-gray-600 mb-2">빠르고 정확한 수리로</h2>
          <h2 className="text-4xl md:text-5xl italic text-gray-500 mb-2">소중한 기기를</h2>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-12">다시 새것처럼</h2>

          <button
            onClick={scrollToContact}
            className="bg-yellow-400 text-[#1a1a1a] px-12 py-4 rounded-full text-3xl font-medium hover:bg-yellow-300 transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg"
          >
            수리문의
          </button>
        </div>
      </div>
    </section>
  );
}
